/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateUnidadeAtividadeFormDto } from '../models/create-unidade-atividade-form-dto';
import { UnidadeAtividadeCriteriaDto } from '../models/unidade-atividade-criteria-dto';
import { UnidadeAtividadeDto } from '../models/unidade-atividade-dto';
import { UnidadeAtividadePageDto } from '../models/unidade-atividade-page-dto';
import { UpdateUnidadeAtividadeFormDto } from '../models/update-unidade-atividade-form-dto';


/**
 * UnidadesAtividade
 */
@Injectable({
  providedIn: 'root',
})
export class UnidadesAtividadeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUnidadesAtividade
   */
  static readonly GetUnidadesAtividadePath = '/unidades-atividade';

  /**
   * Pesquisar unidades de atividade.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnidadesAtividade()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnidadesAtividade$Response(params?: {
    criteria?: UnidadeAtividadeCriteriaDto;
  }): Observable<StrictHttpResponse<UnidadeAtividadePageDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnidadesAtividadeService.GetUnidadesAtividadePath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UnidadeAtividadePageDto>;
      })
    );
  }

  /**
   * Pesquisar unidades de atividade.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUnidadesAtividade$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnidadesAtividade(params?: {
    criteria?: UnidadeAtividadeCriteriaDto;
  }): Observable<UnidadeAtividadePageDto> {

    return this.getUnidadesAtividade$Response(params).pipe(
      map((r: StrictHttpResponse<UnidadeAtividadePageDto>) => r.body as UnidadeAtividadePageDto)
    );
  }

  /**
   * Path part for operation createUnidadeAtividade
   */
  static readonly CreateUnidadeAtividadePath = '/unidades-atividade';

  /**
   * Criar unidade de atividade.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUnidadeAtividade()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUnidadeAtividade$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreateUnidadeAtividadeFormDto
  }): Observable<StrictHttpResponse<UnidadeAtividadeDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnidadesAtividadeService.CreateUnidadeAtividadePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UnidadeAtividadeDto>;
      })
    );
  }

  /**
   * Criar unidade de atividade.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createUnidadeAtividade$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUnidadeAtividade(params?: {

    /**
     * apiRequest
     */
    body?: CreateUnidadeAtividadeFormDto
  }): Observable<UnidadeAtividadeDto> {

    return this.createUnidadeAtividade$Response(params).pipe(
      map((r: StrictHttpResponse<UnidadeAtividadeDto>) => r.body as UnidadeAtividadeDto)
    );
  }

  /**
   * Path part for operation getUnidadeAtividade
   */
  static readonly GetUnidadeAtividadePath = '/unidades-atividade/{id}';

  /**
   * Obter unidade de atividade.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnidadeAtividade()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnidadeAtividade$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<UnidadeAtividadeDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnidadesAtividadeService.GetUnidadeAtividadePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UnidadeAtividadeDto>;
      })
    );
  }

  /**
   * Obter unidade de atividade.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUnidadeAtividade$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnidadeAtividade(params: {
    id: number;
  }): Observable<UnidadeAtividadeDto> {

    return this.getUnidadeAtividade$Response(params).pipe(
      map((r: StrictHttpResponse<UnidadeAtividadeDto>) => r.body as UnidadeAtividadeDto)
    );
  }

  /**
   * Path part for operation updateUnidadeAtividade
   */
  static readonly UpdateUnidadeAtividadePath = '/unidades-atividade/{id}';

  /**
   * Atualizar unidade de atividade.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUnidadeAtividade()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUnidadeAtividade$Response(params: {
    id: number;
    body?: UpdateUnidadeAtividadeFormDto
  }): Observable<StrictHttpResponse<UnidadeAtividadeDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnidadesAtividadeService.UpdateUnidadeAtividadePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UnidadeAtividadeDto>;
      })
    );
  }

  /**
   * Atualizar unidade de atividade.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateUnidadeAtividade$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUnidadeAtividade(params: {
    id: number;
    body?: UpdateUnidadeAtividadeFormDto
  }): Observable<UnidadeAtividadeDto> {

    return this.updateUnidadeAtividade$Response(params).pipe(
      map((r: StrictHttpResponse<UnidadeAtividadeDto>) => r.body as UnidadeAtividadeDto)
    );
  }

  /**
   * Path part for operation ativarUnidadeAtividade
   */
  static readonly AtivarUnidadeAtividadePath = '/unidades-atividade/{id}/ativar';

  /**
   * Ativar Unidade de atividade.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarUnidadeAtividade()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarUnidadeAtividade$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<UnidadeAtividadeDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnidadesAtividadeService.AtivarUnidadeAtividadePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UnidadeAtividadeDto>;
      })
    );
  }

  /**
   * Ativar Unidade de atividade.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarUnidadeAtividade$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarUnidadeAtividade(params: {
    id: number;
  }): Observable<UnidadeAtividadeDto> {

    return this.ativarUnidadeAtividade$Response(params).pipe(
      map((r: StrictHttpResponse<UnidadeAtividadeDto>) => r.body as UnidadeAtividadeDto)
    );
  }

  /**
   * Path part for operation desativarUnidadeAtividade
   */
  static readonly DesativarUnidadeAtividadePath = '/unidades-atividade/{id}/desativar';

  /**
   * Desativar Unidade de atividade.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarUnidadeAtividade()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarUnidadeAtividade$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<UnidadeAtividadeDto>> {

    const rb = new RequestBuilder(this.rootUrl, UnidadesAtividadeService.DesativarUnidadeAtividadePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UnidadeAtividadeDto>;
      })
    );
  }

  /**
   * Desativar Unidade de atividade.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarUnidadeAtividade$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarUnidadeAtividade(params: {
    id: number;
  }): Observable<UnidadeAtividadeDto> {

    return this.desativarUnidadeAtividade$Response(params).pipe(
      map((r: StrictHttpResponse<UnidadeAtividadeDto>) => r.body as UnidadeAtividadeDto)
    );
  }

}
